import { AppDetailsPopover } from './AppDetailsPopover';
import { AppDisplay } from './AppDisplay';
import { NotMonitoredLabel } from './NotMonitoredLabel';
import React from 'react';
import { Else, If, Then, When } from 'react-if';
import { Space } from 'antd';
export const AppList = ({ appIds, direction, showNotMonitored }) => {
    if (!appIds.length) {
        return null;
    }
    return (React.createElement(Space, { align: 'start', direction: direction, size: direction === 'horizontal' ? 0 : 4 },
        React.createElement(If, { condition: appIds.length === 1 && appIds[0] === -1 },
            React.createElement(Then, null,
                React.createElement(When, { condition: showNotMonitored },
                    React.createElement(NotMonitoredLabel, null))),
            React.createElement(Else, null, appIds.map((appId) => React.createElement(AppDetailsPopover, { appId: appId, key: appId },
                React.createElement(AppDisplay, { appId: appId })))))));
};
